// Wordmark logo-ul oficial daruto (frontend/public/logo.png, aspect ~3.34:1).
// Prop `size` controlează înălțimea în pixeli (lățimea se scalează automat).

export function Logo({ size = 32, className = '' }) {
  return (
    <img
      src="/logo.png"
      alt="daruto"
      height={size}
      style={{ height: size, width: 'auto' }}
      className={className}
      draggable={false}
    />
  );
}
